module.exports = __webpack_public_path__ + "assets/imgs/logos/unity.bb215f6c1e0600a6995111a90eac6b8a.png";